export default {
    blogTitle: 'TL\'s Blog',
    // will be used to set link address, and retrive data from GitHub
    username: 'tianhanl'
};



// WEBPACK FOOTER //
// ./src/config.js